var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi621995Hover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_621995",
    clipPath: "url(#clip0_2040_5424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.3334 0H6.48551C6.16351 0 5.90216 0.261352 5.90216 0.583352C5.90216 0.905352 6.16231 1.1667 6.48551 1.1667C8.24601 1.1667 9.80236 2.28905 10.3589 3.9562L10.4615 4.2677C10.5397 4.50685 10.7637 4.66905 11.0157 4.66905L24.5 4.66665C24.8104 4.66665 25.1335 4.7133 25.5197 4.81365C25.5687 4.8265 25.6177 4.8323 25.6667 4.8323C25.7938 4.8323 25.921 4.7903 26.0237 4.71095C26.1672 4.60009 26.25 4.4298 26.25 4.24895V2.91665C26.25 1.309 24.9422 0 23.3334 0Z",
    fill: "#D42124"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.4987 5.83331H11.0132C10.2595 5.83331 9.59218 5.35266 9.35418 4.63746L9.25153 4.3271C8.85253 3.13475 7.74068 2.33325 6.48418 2.33325H3.49868C1.88983 2.33325 0.582031 3.64225 0.582031 5.2499V19.2499C0.582031 20.8575 1.88988 22.1665 3.49868 22.1665H5.83203C6.15403 22.1665 6.41538 21.9052 6.41538 21.5832C6.41533 17.402 9.81733 14 13.9987 14C18.18 14 21.582 17.402 21.582 21.5833C21.582 21.9053 21.8434 22.1667 22.1654 22.1667H24.4987C26.1075 22.1667 27.4153 20.8577 27.4153 19.25V8.74995C27.4153 7.14231 26.1075 5.83331 24.4987 5.83331Z",
    fill: "#D42124"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9987 15.1665C10.4613 15.1665 7.58203 18.0447 7.58203 21.5832C7.58203 25.1217 10.4613 27.9999 13.9987 27.9999C17.536 27.9999 20.4153 25.1217 20.4153 21.5832C20.4153 18.0447 17.536 15.1665 13.9987 15.1665ZM17.9117 19.6629L13.245 24.3295C13.1307 24.4427 12.9814 24.4999 12.832 24.4999C12.6827 24.4999 12.5334 24.4427 12.419 24.3295L10.0857 21.9962C9.85818 21.7687 9.85818 21.3988 10.0857 21.1713C10.3132 20.9438 10.683 20.9438 10.9105 21.1713L12.8309 23.0917L17.0845 18.838C17.312 18.6105 17.6819 18.6105 17.9094 18.838C18.1368 19.0655 18.1392 19.4342 17.9117 19.6629Z",
    fill: "#D42124"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2040_5424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi621995Hover);
export default __webpack_public_path__ + "static/media/fi_621995hover.f7f2996e1d50aa2943744e19a86ef6a0.svg";
export { ForwardRef as ReactComponent };